export const EST_MIN_SITES = 5;
export const EST_MAX_SITES = 25;
export const EST_MIN_API_CALLS = 200000;
export const EST_MAX_API_CALLS = 1000000;
export const EST_MIN_HOD_API_CALLS = 40000;
export const EST_MAX_HOD_API_CALLS = 200000;
export const EST_BASE_APP_POINTS = 10;
export const DEFAULT_SITES_APP_POINT = 5;
export const DEFAULT_API_CALLS_APP_POINT = 10;
export const DEFAULT_HOD_API_CALLS_POINT = 4;
export const STD_BASE_APP_POINTS = 75;
export const YEARLY = 12;
export const DISCOUNT_PCT = 0.9;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30EIS = '30DFS';
